import CookieBasedCommands from "./utils/cookie-based-commands";
import { command_definitions } from "./utils/cookie_based_command_definitions";

export const quickSignUp = function () {
    const { prepopulate_signup_form } = command_definitions;

    const populate_element = function (input_element, new_value) {
        if (input_element.value) {
            return;
        }

        input_element.value = new_value;
    };

    const quick_sign_up_commands = {
        [prepopulate_signup_form]: function (fields) {
            const decoded_fields = JSON.parse(fields);
            const input_ids = ["first_name", "last_name", "email", "phone"];

            input_ids.forEach((input_id) => {
                if (decoded_fields[input_id]) {
                    const input_elements = document.getElementsByName(input_id);

                    input_elements.forEach((input_element) =>
                        populate_element(input_element, decoded_fields[input_id]),
                    );
                }
            });
        },
    };

    const cookieBasedCommands = new CookieBasedCommands(quick_sign_up_commands);

    const registerInputValue = function (input_id, value) {
        let command_value = cookieBasedCommands.getCommand(prepopulate_signup_form) ?? "{}";
        command_value = JSON.parse(command_value);

        const new_value = { ...command_value, ...{ [input_id]: value } };

        cookieBasedCommands.registerCommand(prepopulate_signup_form, JSON.stringify(new_value));
    };

    const prepopulateSignUpForm = function () {
        cookieBasedCommands.executeCommands();
    };

    return {
        registerInputValue,
        prepopulateSignUpForm,
    };
};

const ready = function (callback) {
    if (document.readyState !== "loading") {
        callback();
        return;
    }

    document.addEventListener("DOMContentLoaded", callback);
};

ready(function () {
    const qs = quickSignUp();

    const quick_capture_inputs = document.querySelectorAll(".capture_quick_sign_up");

    quick_capture_inputs.forEach((input) => {
        input.addEventListener("blur", function () {
            const name = input.getAttribute("name");
            const value = input.value;

            qs.registerInputValue(name, value);
        });
    });

    qs.prepopulateSignUpForm();
});
